/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsDoubleMiniLeft: {
  name: 'chevrons-double-mini-left';
  data: string;
} = {
  name: 'chevrons-double-mini-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.354 6.354a.5.5 0 1 0-.708-.708l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 8l1.647-1.646Zm4 0a.5.5 0 0 0-.708-.708l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L9.707 8l1.647-1.646Z" fill="currentColor"/></svg>`,
};
